<template>
	<div>
		<div class="academe flex-row">
			<div class="left">
				<div class="tabs">
					<el-tabs v-model="activeValue" @tab-click="handleClick" :stretch="true">
						<el-tab-pane label="合规课堂" name="1"></el-tab-pane>
						<el-tab-pane label="合规培训" name="2"></el-tab-pane>
						<el-tab-pane label="行业热点" name="3"></el-tab-pane>
					</el-tabs>
				</div>
				<div class="List flex-column" v-if="activeValue != 2">
					<div class="item flex-row cursor" @click="to2(item.url)" v-for="(item, index) in activeValue == 1 ? list : list2">
						<div class="itemLeft"><el-image :src="item.advertisingPic" fit="cover"></el-image></div>
						<div class="itemRight flex-column">
							<div>{{ item.title }}</div>
							<div>{{ item.summary }}</div>
							<div class="flex-row">
								<div>{{ item.creationTime }}</div>
								<div class="">阅读全文>></div>
							</div>
						</div>
						<div class="line"></div>
					</div>
				</div>
				<div class="List2 train flex-column" v-else>
					<div>特邀讲师</div>
					<div class="expertList">
						<div class="flex-column trainItem" v-for="item in expertList" @click="to(item)">
							<div class=" flex-row flex-center"><el-image :src="item.profile" fit="cover"></el-image></div>
							<div class="flex-column">
								<div>{{ item.name }}</div>
								<div>{{ item.description }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="pagination" v-if="activeValue == 1">
					<el-pagination
						@current-change="handleCurrentChange1"
						:current-page="activeValue == 1 ? currentPage1 : currentPage3"
						:page-size="5"
						layout=" prev, pager, next, jumper"
						:total="activeValue == 1 ? total1 : total3"
					></el-pagination>
				</div>
				<div class="pagination" v-if="activeValue == 2">
					<el-pagination
						@current-change="handleCurrentChange2"
						:current-page="currentPage2"
						:page-size="6"
						layout=" prev, pager, next, jumper"
						:total="total2"
					></el-pagination>
				</div>
				<div class="pagination" v-if="activeValue == 3">
					<el-pagination
						@current-change="handleCurrentChange3"
						:current-page="activeValue == 1 ? currentPage1 : currentPage3"
						:page-size="5"
						layout=" prev, pager, next, jumper"
						:total="activeValue == 1 ? total1 : total3"
					></el-pagination>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
import { getLearningMaterialList, getIndustryExpertList } from '@/api/complianceStudy/complianceStudy.js';
export default {
	data() {
		return {
			currentPage1: 1,
			currentPage2: 1,
			currentPage3: 1,
			activeValue: '1',
			total1: 10,
			total2: 10,
			total3: 10,
			list: [],
			list2: [],
			expertList: []
		};
	},
	mounted() {
		this.getLearningMaterialList(this.currentPage1, this.activeValue);
	},
	methods: {
		to2(url) {
			window.open(url);
		},
		getLearningMaterialList(pageIndex, materialType) {
			let obj = {
				pageIndex: pageIndex,
				pageSize: 5,
				industryExpertId: '',
				materialType: materialType
			};
			getLearningMaterialList(obj).then(({ data: res }) => {
				if (materialType == 3) {
					this.list2 = res.data.items;
					this.total3 = res.data.totalCount;
					this.list2.map(item => {
						item.creationTime = moment(item.creationTime).format('YYYY-MM-DD');
						return item;
					});
				} else {
					this.list = res.data.items;
					this.total1 = res.data.totalCount;
					this.list.map(item => {
						item.creationTime = moment(item.creationTime).format('YYYY-MM-DD');
						return item;
					});
				}
			});
		},
		getIndustryExpertList(pageIndex) {
			let obj = {
				pageIndex: pageIndex,
				pageSize: 6
			};
			getIndustryExpertList(obj).then(({ data: res }) => {
				this.expertList = res.data.items;
				this.total2 = res.data.totalCount;
			});
		},
		to(data) {
			this.$router.push({
				path: '/classroom',
				query: data
			});
		},
		//页面更改1
		handleCurrentChange1(page) {
			this.currentPage1 = page;
			this.getLearningMaterialList(this.currentPage1, this.activeValue);
		},
		//页面更改2
		handleCurrentChange2(page) {
			this.currentPage2 = page;
			this.getIndustryExpertList(this.currentPage2);
		},
		//页面更改3
		handleCurrentChange3(page) {
			this.currentPage3 = page;
			this.getLearningMaterialList(this.currentPage3, this.activeValue);
		},
		//tabs切换
		handleClick() {
			if (this.activeValue == 2) {
				if (this.expertList.length == 0) {
					this.currentPage2 = 1;
					this.getIndustryExpertList(this.currentPage2);
				}
			} else {
				if (this.activeValue == 1 && this.list.length == 0) {
					this.currentPage1 = 1;
					this.getLearningMaterialList(this.currentPage1, this.activeValue);
				} else if (this.activeValue == 3 && this.list2.length == 0) {
					this.currentPage3 = 1;
					this.getLearningMaterialList(this.currentPage3, this.activeValue);
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.left {
	width: 764px;
	height: 1300px;
	background: #ffffff;
	box-shadow: 0px 5px 8px 0px rgba(212, 212, 212, 0.5), 0px -5px 8px 0px rgba(225, 225, 225, 0.5);
	border: 1px solid #ffffff;
	.tabs {
		height: 85px;
	}
	.train {
		> :first-child {
			font-size: 22px;
			font-weight: 600;
			color: #333333;
		}
		.expertList {
			width: 100%;
			height: 900px;
			display: flex;
			flex-wrap: wrap;
			align-content: flex-start;
			// justify-content: space-evenly;
			// background: red;
			> :not(:nth-child(2n)) {
				margin-right: 57px;
				margin-left: 57px;
			}
		}
		.trainItem {
			transition: all 0.3s;
			margin-top: 33px;
			width: 254px;
			height: 223px;
			background: #ffffff;
			box-shadow: 0px 5px 8px 0px rgba(212, 212, 212, 0.5), 0px -5px 8px 0px rgba(225, 225, 225, 0.5);
			border-radius: 4px;
			// justify-content: space-between;
			overflow: hidden;
			> :first-child {
				width: 254px;
				height: 143px;
				align-items: flex-start;
			}
			> :last-child {
				margin-top: 5px;
				align-items: center;
				width: 254px;
				height: 80px;
				justify-content: center;
				> :first-child {
					font-size: 18px;
					font-weight: 600;
					color: #333333;
				}
				> :last-child {
					text-align: center;
					width: 140px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					-o-text-overflow: ellipsis;
					font-size: 14px;
					font-weight: 400;
					color: #666666;
					line-height: 30px;
				}
			}
		}
		.trainItem:hover {
			transform: scale(1.03);
		}
	}
	.List {
		width: 679px;
		height: 970px;
		margin: 0 auto;
		margin-top: 42px;
		> :not(:first-child) {
			margin-top: 60px;
			.line {
				position: absolute;
				top: -30px;
				width: 100%;
				height: 2px;
				background-color: #e6e6e6;
			}
		}
		> :first-child {
			.line {
				position: absolute;
			}
		}

		.item {
			position: relative;
			width: 100%;
			height: 146px;
			justify-content: space-between;
			.itemLeft {
				transition: all 0.3s;
				width: 316px;
				height: 146px;
				// background: cyan;
				text-align: center;
				line-height: 146px;
				font-size: 28px;
			}
			.itemRight {
				height: 146px;
				justify-content: space-between;
				> :nth-child(1) {
					width: 338px;
					font-size: 18px;
					font-weight: 400;
					color: #333333;
					line-height: 25px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					word-break: break-all;
				}
				> :nth-child(2) {
					width: 338px;
					height: 40px;
					font-size: 14px;
					font-weight: 400;
					color: #666666;
					line-height: 20px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					word-break: break-all;
				}
				> :nth-child(3) {
					justify-content: space-between;
					font-size: 14px;
					font-weight: 400;
					color: #999999;
					> :last-child {
						color: $global-default-primary;
					}
				}
			}
		}
		.item:hover .itemLeft {
			transform: scale(1.03);
		}
	}

	.List2 {
		width: 679px;
		height: 970px;
		margin: 0 auto;
		margin-top: 42px;
	}
}
</style>
